export const SET_ENCOUNTER= 'Set encounter'
export const SET_PATIENT_CURRENT_ENCOUNTER= 'Set current patient encounter'
export const SET_ENCOUNTERS= 'Set encounters'
export const DELETE_ENCOUNTER= 'Delete encounter'
export const UPDATE_ENCOUNTER= 'Update encounter'
export const SET_ENCOUNTER_STATE= 'Set encounter state'
export const SET_PATIENT_CURRENT_ENCOUNTER_OVERRIDE= 'Set current encounter override'

// labs and service requests
